import { render, staticRenderFns } from "./OrganizationSetup.vue?vue&type=template&id=5b631f07&scoped=true&"
import script from "./OrganizationSetup.vue?vue&type=script&lang=js&"
export * from "./OrganizationSetup.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSetup.vue?vue&type=style&index=0&id=5b631f07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b631f07",
  null
  
)

export default component.exports